import TiptapBulletList from '@tiptap/extension-bullet-list';

export const BulletList = TiptapBulletList.extend({
  marks: 'if'
});
